export const isNullOrUndefined = (value: unknown): boolean =>
    value === null || value === undefined;

export const identity = <T>(value: T): T => value;

export function timeToMilliseconds(date: Date): number {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const milliseconds = date.getMilliseconds();
    return (hours * 3600000) + (minutes * 60000) + (seconds * 1000) + milliseconds;
}

export function safeNumberConversion(value: unknown): number | null {
    if (isNullOrUndefined(value)) return null;

    const num = Number(value);
    return isNaN(num) ? null : num;
}

export function safeISODateConversion(value: unknown): string | null {
    if (isNullOrUndefined(value)) return null;

    try {
        const date = new Date(String(value));
        return !isNaN(date.getTime()) ? date.toISOString() : null;
    } catch (e) {
        return null;
    }
}